import { render, staticRenderFns } from "./infoRow.vue?vue&type=template&id=8f122860&scoped=true&"
import script from "./infoRow.vue?vue&type=script&lang=js&"
export * from "./infoRow.vue?vue&type=script&lang=js&"
import style0 from "./infoRow.vue?vue&type=style&index=0&id=8f122860&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f122860",
  null
  
)

export default component.exports